<template>
  <div>
    <app-background :backgroundImg="'./static/images/' + sharedContent.backgroundImg"/>
    <app-nav-attract/>
  </div>
</template>

<script>
import appAudio from './../partials/audio'
import appBackground from './../partials/background'
import appNavAttract from './../partials/navAttract'
export default {
  components: {
    appAudio,
    appBackground,
    appNavAttract
  },

  computed: {
    sharedContent () {
      return this.$store.getters.sharedContent
    }
  },

  created () {
    this.$http.get('./static/images/primary-bg-blur.jpg')
    this.$http.get('./static/images/explore/wolf-bg-blur.jpg')
    this.$http.get('./static/images/landscape/landscape-without-bg-blur.jpg')
    this.$http.get('./static/data/gallery.json')
    .then(response => {
      return response
    })
    .then(data => {
      data.body.sections.forEach(section => {
        section.previewImages.forEach(img => {
          this.$http.get('./static/images/gallery' + '/' + section.directory + '/' + img.fileName)
        })
      })
    })
    .catch(err => {
      console.log(err)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/routes/index.vue